import { render, staticRenderFns } from "./BlockType13List.vue?vue&type=template&id=769ce208&scoped=true&"
import script from "./BlockType13List.vue?vue&type=script&lang=ts&"
export * from "./BlockType13List.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType13List.vue?vue&type=style&index=0&id=769ce208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769ce208",
  null
  
)

export default component.exports